import {Field, Formik, FormikHelpers as FormikActions, useField, useFormik, useFormikContext} from 'formik';
import {default as React, useEffect, useState} from 'react';
import {Button} from '~/components/Button';
import {InputType} from '~/components/Controls/Input';
import {Form, FormColumn, FormControls, FormRow, FormTitle, InputField, IntentText, SelectField} from '~/components/Form';
import {IModalComponent, IModalComponentClose} from '~/components/Modal';
import {Intent} from '~/lib/intent';
import {
    IUserPermission, MediationPartnerType,
    mediationPartnerTypes, PermissionResourceType,
    permissionResourceTypes,
    UserPermissionSchema
} from '~/modules/Users/models/UserPermission';

interface IUserPermissionForm {
    permission?: IUserPermission;
    title?: string;
    onSubmit?: (values: IUserPermission, formikActions: FormikActions<IUserPermission>, close: IModalComponentClose) => void;
}

export const UserPermissionForm: IModalComponent<IUserPermissionForm> = props => <Formik initialValues={props.permission}
    validationSchema={UserPermissionSchema}
    onSubmit={(user, actions) => props.onSubmit(user, actions, props.close)}
>
    {({status, values, isSubmitting}) => <Form>
        <FormTitle>{props.title}</FormTitle>
        {status && <IntentText intent={Intent.DANGER}>{status}</IntentText>}
        <FormRow>
            <FormColumn>
                <Field name='resourceType'
                    options={{
                        placeholder: 'ResourceLoader Type',
                        items: permissionResourceTypes.map(option => ({
                            label: option,
                            value: option
                        })),
                        disabled: isSubmitting
                    }}
                    label='Resource Type'
                    component={SelectField}
                />
                {values.resourceType === PermissionResourceType.MEDIATIONPARTNER ?
                    <Field name='resourceId'
                        options={{
                            placeholder: 'Mediation Partner ID',
                            items: mediationPartnerTypes.map(option => ({
                                label: option,
                                value: MediationPartnerType[option]
                            })),
                            disabled: isSubmitting
                        }}
                        label='Resource ID'
                        component={SelectField}
                    /> :
                    <Field name='resourceId'
                        options={{
                            placeholder: 'ResourceLoader ID',
                            type: InputType.INTEGER,
                            disabled: isSubmitting
                        }}
                        label='Resource ID'
                        type='number'
                        component={InputField}
                    />
                }
            </FormColumn>
        </FormRow>
        <FormControls>
            <Button disabled={isSubmitting}
                onClick={props.close}
            >Cancel</Button>
            <Button type='submit'
                disabled={isSubmitting}
                intent={Intent.DANGER}
                rightIcon={isSubmitting && <i className='fa fa-spinner fa-spin'/>}
            >Save</Button>
        </FormControls>
    </Form>}
</Formik>;
